import clsx from 'clsx'
import { HTMLAttributes } from 'react'

const colorClasses = {
  inherit: 'stroke-current',
  primary: 'stroke-primary-600',
  secondary: 'stroke-secondary-500',
  textPrimary: 'stroke-black',
  textSecondary: 'stroke-gray-500',
  accent: 'stroke-white',
  success: 'stroke-success-900',
  error: 'stroke-error-500',
}

interface CircularProgressProps extends HTMLAttributes<SVGElement> {
  color?: keyof typeof colorClasses
  strokeWidth?: number
}

const CircularProgress: React.FC<CircularProgressProps> = ({
  color = 'inherit',
  strokeWidth = 2,
  className,
  ...rest
}) => {
  const commonProps = {
    cx: '12',
    cy: '12',
    r: 12 - strokeWidth / 2,
    className: colorClasses[color],
    strokeWidth: strokeWidth,
    fill: 'transparent',
  }

  return (
    <svg
      role='progressbar'
      {...rest}
      className={clsx('animate-spin', className)}
      viewBox='0 0 24 24'>
      <circle {...commonProps} opacity={0.3} />
      <circle
        {...commonProps}
        strokeLinecap='butt'
        strokeDasharray={`${(2 * Math.PI * commonProps.r) / 5} 999999`}
      />
    </svg>
  )
}

export default CircularProgress
